export default {"src":"/_next/static/media/imdb.7069b47f.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};